var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-checkout",class:_vm.gray ? 'my-gray' : 'black',attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"block":"","depressed":"","height":"56px"},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }